// SEO-EXPANSION v4: additive, no behavior change to existing pages.
import type { IntentNode } from "@/lib/seo/intent-registry";
import { generateIntentCopy } from "@/lib/seo/copy-generator";

export function buildIntentJsonLd(node: IntentNode, url: string) {
  const copy = generateIntentCopy(node);
  return [
    {
      "@context": "https://schema.org",
      "@type": "FinancialProduct",
      name: node.exactKeyword,
      category: `${node.metal} bullion`,
      url,
    },
    {
      "@context": "https://schema.org",
      "@type": "Dataset",
      name: `${node.exactKeyword} — live rate dataset`,
      description: `Minute-refreshed ${node.metal} spot rate converted to ${node.currency} per ${node.unit}.`,
      keywords: [node.metal, node.unit, node.currency, node.region].join(","),
      url,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: copy.faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://drhint.com/" },
        { "@type": "ListItem", position: 2, name: "Rates", item: "https://drhint.com/rates" },
        { "@type": "ListItem", position: 3, name: node.exactKeyword, item: url },
      ],
    },
  ];
}